import {Column} from "primereact/column";
import React from "react";
import {TreeTable} from "primereact/treetable";
import _ from 'lodash';
import MainLayout from 'layouts/MainLayout';
import {useTaskSummary} from "../../hooks/taskHooks";
import { Tooltip } from 'primereact/tooltip';


const KPITaskSummaryTable = () => {
    
    
    const taskSummary = useTaskSummary();
    
    
    const percentualTemplate = (row, valueStr) => {
        const valNumeric = !row?.data?.assignedTasks ? 0 : (row.data[valueStr] / row.data.assignedTasks);
        const valPercent = (Number(valNumeric).toLocaleString(undefined,{style: 'percent', minimumFractionDigits:1}));
        const tooltipId = `custom-target-icon-${row.id}-${valueStr}`;
        return (
            <div>
                <Tooltip target={`.${tooltipId}`} />
                {valPercent}
                <i className={`pi pi-info-circle pl-1 ${tooltipId}`} data-pr-tooltip={`${row.data[valueStr]} out of ${row.data.assignedTasks} tasks`}
                data-pr-position="left"
                data-pr-at="left+5 top"
                data-pr-my="left center-2"/>
            </div>
        )
    }
       


    return (
        <MainLayout>
            <div className="kpi-target-table">
                <div className="mobile-horizontal-scrollable">
                <TreeTable value={taskSummary} loading={!taskSummary} responsiveLayout="scroll"  emptyMessage="No Tasks" className="task-table" >
                    <Column field="name" header="Department Name" sortable expander/>
                    <Column field="assignedTasks" header="Assigned" sortable />
                    <Column field="taskCompletion" header="Completed" sortable body={row => percentualTemplate(row, "taskCompletion")}/>
                    <Column field="taskAcceptance" header="Not Accepted" body={row => percentualTemplate(row, "taskAcceptance")}/>
                    <Column field="taskNotStarted" header="Not Started" sortable body={row => percentualTemplate(row, "taskNotStarted")}/>
                    <Column field="taskStarted" header="Started" sortable body={row => percentualTemplate(row, "taskStarted")}/>
                    <Column field="activeTasks" header="Active Task" body={row => percentualTemplate(row, "activeTasks")}/>
                    <Column field="lateTasks" header="Late Tasks" body={row => percentualTemplate(row, "lateTasks")}/>
                </TreeTable>
                </div>
            </div>
        </MainLayout>
    )
}

export default KPITaskSummaryTable;
